import React, { useEffect } from "react";
import FormComponent from "./FormComponent";
import "./banner.css"
import Aos from "aos";
import 'aos/dist/aos.css'

function Banner() {
    useEffect(() => {
        Aos.init({
            once: true,
            duration: 500,
        });
    }, [])
    return (
        <>
            <section id="banner" className="position-relative">

                <div className="container-lg g-0 px-md-2">
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-xl-8 position-relative z-3 banner-wrapper">
                            <div className="bannerlist px-3 px-lg-0 mt-3 mt-md-0">
                                <h1 data-aos="fade-up" data-aos-delay="100" data-aos-duration="800">Banking Made Easy<br />for Senior Citizens</h1>
                            </div>
                            <div className="featlist px-3 px-lg-0">
                                <div data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">
                                    <img src="dist/img/icons/banner01.svg" alt="" width={33} height={33} />
                                    <p>Fixed Deposit with  <br /> monthly interest payout</p>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="400" data-aos-duration="800">
                                    <img src="dist/img/icons/banner02.svg" alt="" width={33} height={33} />
                                    <p>Digital <br /> Convenience</p>
                                </div>
                                <div data-aos="fade-up" data-aos-delay="500" data-aos-duration="800">
                                    <img src="dist/img/icons/banner03.svg" alt="" width={33} height={33} />
                                    <p>Additional Security   <br />Layer with SmartLock</p>
                                </div>
                            </div>
                            <img src="dist/img/man_desktop.webp" alt="" className="desktop_men d-none d-md-block" data-aos="fade-in" data-aos-delay="600" data-aos-duration="800" data-aos-offset="0" width={400} />
                            <img src="dist/img/man-mobile.webp" alt="" className="desktop_men d-md-none" data-aos="fade-in" data-aos-delay="600" data-aos-duration="800" data-aos-offset="0" width={280} />
                        </div>
                        <div className="col-md-10 col-lg-5 col-xl-4 px-3 position-relative d-flex align-items-center">
                            <FormComponent></FormComponent>
                        </div>
                    </div>
                </div>

            </section>
        </>
    );
}

export default Banner;
